export default __webpack_public_path__ + "static/media/convoy-background.468d7fcc.png";